import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {IKPIConfigData} from "app/modules/settings/services/kpi-config.service";

@Injectable({
    providedIn: 'root',
})
export class KpiDistributionAnalysisService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/KpiDistributions').replace(
        '{version}',
        this.version
    );
    constructor(private http: HttpClient) {}

    getKpiDistributions(parameters: IDistributionParameters): Observable<IKPIDistribution> {
        return this.http.post<IKPIDistribution>(this._url + '/GetKpiDistributions/', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    setDistributionParameters(data: IKPIConfigData, 
                              cleanedByMinAndMax: '0' | '1',
                              getCleanedData:  '0' | '1',
                              isShowNonZeroDataOnly: '0' | '1' = '1') {
        let parametes: IDistributionParameters = 
        {
            fromDatePeriod: 'Trailing 36m',
            staffingKey: data.staffingKey.toString(),
            milestoneKey: data.milestoneKey.toString(),
            category: 'KPIValue',
            getCleanedData: getCleanedData,
            toMilestoneKey: data.toMilestoneKey ? data.toMilestoneKey.toString() : '',
            cleanedByMinAndMax: cleanedByMinAndMax,
            displayShort: data.kpiDisplayShort,
            ddbIdentifier: data.ddbIdentifier,
            positionAbbv: data.positionAbbv ?? 'LO',
            customTag: data.kpiCustomTag,
            bpsDisplay: data.kpiBpsDisplay,
            isShowNonZeroDataOnly: isShowNonZeroDataOnly,
        };     
        return  Object.assign({} ,parametes);
    }
}

export interface IDistributionParameters {
    fromDatePeriod: string;
    milestoneKey: string;
    staffingKey?: string;
    category: string;
    getCleanedData: '1' | '0';
    cleanedByMinAndMax: '1' | '0';
    displayShort: string;
    ddbIdentifier: string;
    interQuartileMin?: string;
    interQuartileMax?: string;
    toMilestoneKey: string;
    givenMin?: string;
    givenMax?: string;
    positionAbbv: string;
    bpsDisplay: string;
    customTag: string;
    isShowNonZeroDataOnly: '0' | '1'; 
}

export interface IKPIDistribution {
    binInfoArray?: Array<IDistributionValue>;
    outliersArray?: Array<IDistributionData>;
    mean: number;
    std: number;
    min: number;
    max: number;
    interQuartileMin?: number;
    interQuartileMax?: number;
    quartile1?: number;
    quartile2?: number;
    quartile3?: number;
    median: number;
    mode: number;
    count: number;
    numberOfBins?: number;
    outlierCount: number;
    cleanedByMinAndMax: '1' | '0';
}

export interface IDistributionValue {
    bin: string;
    name: string;
    y: number;
    x: number;
    count: number;
    binStart: number;
    binEnd: number;
    probability: number;
}

export interface IDistributionData {
    yearMonthCalendar: string;
    employeeIdentifier: string;
    employeeName: string;
    units: number;
    volume: number;
    kpiType: string;
    kpiValue: number;
}

export interface IDistributionMetrics {
    mean: string;
    median: string;
    min: string;
    max: string;
    std: string;
    mode: string;
    count: string;
    outlierCount: string;
}